import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

export type DividerLayout = 'default' | 'withContent';
export type DividerMode = 'default' | 'dotted';
export type DividerColor = 'default' | 'onBody';

@Component({
    selector: 'lib-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DividerComponent {
	public readonly layout = input<DividerLayout>('default');
	public readonly mode = input<DividerMode>('dotted');
	public readonly color = input<DividerColor>('default');

	@HostBinding('style') style = 'display: block';
}
